import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { Memory, MemoryCustomCover, MemoryPayload } from '../../common/models'

export const getAllMemories = (params?: PaginationParams) =>
  http.get<Pagination<Memory>>('/operations/memories', {
    params,
  })

export const createMemory = (data: MemoryPayload) =>
  http.post<Memory>('/operations/memories/item', data)

export const updateMemory = (id: string, data: MemoryPayload) =>
  http.put<Memory>(`/operations/memories/item/${id}`, data)

export const unpublishMemory = (ids: string[]) =>
  http.put<Memory[]>('/operations/memories/item/unpublish', {
    ids,
  })

export const publishMemory = (ids: string[]) =>
  http.put<Memory[]>('/operations/memories/item/publish', {
    ids,
  })

export const deleteMemory = (id: string) =>
  http.delete(`/operations/memories/${id}`)

export const getMemory = (id: string) =>
  http.get<Memory>(`/operations/memories/item/${id}`)

export const getMemoryCustomCover = () =>
  http.get<MemoryCustomCover>(`/operations/memories/cover-image`)

export const updateMemoryCustomCover = (data: MemoryCustomCover) =>
  http.put<MemoryCustomCover>(`/operations/memories/cover-image`, data)
